'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (title) {
    return (0, _isString2.default)(title) ? _extends({}, DEFAULT_AXIS_TITLE, {
        text: title
    }) : {
        text: null
    };
};

var _isString = require('d2-utilizr/lib/isString');

var _isString2 = _interopRequireDefault(_isString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_AXIS_TITLE = {
    align: 'low',
    margin: 15,
    style: {
        color: '#222',
        textShadow: '0 0 #999',
        fontSize: '13px'
    }
};

;
//# sourceMappingURL=getAxisTitle.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/adapters/dhis_highcharts/getAxisTitle.js
 ** module id = 71
 ** module chunks = 0 1
 **/